module.exports = __webpack_public_path__ + "static/img/dummyimg.f3556f3b.jpg";